import React from "react";
// import ErrorImage from "../images/404-error-1.png";
// import ErrorImage2 from "../images/404-error-2.jpg";

const error404 = () => (
  <div style={{ textAlign: "center" }}>
    <p style={{ position: "absolute", top: "26%", left: "45%" }}>
      OOPS! PAGINA NO ENCONTRADA
    </p>
    <h1 style={{ fontSize: 180 }}>404</h1>
    <p style={{ position: "absolute", top: "54%", left: "40%" }}>
    NO SE ENCUENTRA LA PÁGINA QUE SOLICITÓ
    </p>
  </div>
);

export default error404;
